const FIREBASE_NODE = process.env.REACT_APP_FIREBASE_NODE;
const DATABASE_URL = process.env.REACT_APP_DATABASE_URL;
const AUTH_DOMAIN = process.env.REACT_APP_AUTH_DOMAIN;
const API_KEY = process.env.REACT_APP_API_KEY;
const STORAGE_BUCKET = process.env.REACT_APP_STORAGE_BUCKET;

export default {
    FIREBASE_NODE,
    DATABASE_URL,
    AUTH_DOMAIN,
    API_KEY,
    STORAGE_BUCKET
}

export {
    FIREBASE_NODE,
    DATABASE_URL,
    AUTH_DOMAIN,
    API_KEY,
    STORAGE_BUCKET,
}


// WEBPACK FOOTER //
// ./src/config/firebase.config.ts